import { history } from "@umijs/max";
import axios from "axios";

// have problems with env file in production
// todo fix env file in production and delete this hard code in future
const BASE_URL =
  process.env.BASE_URL || "https://appss-back-p.engagelabs.org/stats";

const $api = axios.create({ baseURL: BASE_URL });

const loginPath = "/user/login";

$api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && config.headers && config.url !== "/admin/register") {
    config.headers.Authorization = `${token}`;
  }
  return config;
});

$api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      history.push(loginPath);
    }
    return Promise.reject(error);
  }
);

export default $api;
